import { getSocketInstance } from '../helpers/websocket';
import { CONNECT_SOCKET, DISCONNECT_SOCKET, SUBSCRIBE, UNSUBSCRIBE, LOGOUT, SEND_COMMAND } from "../constants/action-types";
import { socketError, connectedSocket, messageReceived, liveMessage } from '../actions/socket';

const socketMiddleware = store => {
    let socketClient = null;

    return next => action => {
        switch (action.type) {
            case CONNECT_SOCKET: {
                socketClient = getSocketInstance();
                if (!socketClient) return store.dispatch(socketError('Web socket connection error'));

                socketClient.connect(err => {
                    if (err) {
                        store.dispatch(socketError(err));
                        store.dispatch(connectedSocket(false));
                    } else store.dispatch(connectedSocket(true));
                });

                socketClient.onMessage(data => {
                    store.dispatch(messageReceived(data));

                    const live = { ...data };
                    store.dispatch(liveMessage(live));
                });
                window.socketClient = socketClient;
                break;
            }
            case DISCONNECT_SOCKET:
                if (socketClient) {
                    socketClient.destroy();
                    window.socketClient = null;
                }
                break;
            case SUBSCRIBE:
                if (socketClient) socketClient.subscribe(action.notifications, action.group);
                break;
            case UNSUBSCRIBE:
                if (socketClient) socketClient.unsubscribe(action.group);
                break;
            case SEND_COMMAND:
                if (socketClient) socketClient.sendCommand(action.params);
                break;
            case LOGOUT:
                if (socketClient) {
                    socketClient.destroy();
                    window.socketClient = null;
                }
                break;
            default:
                break;
        }

        return next(action);
    };
};

export default socketMiddleware;